import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class ExportCollectionsProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('export-collections', query)
  }

  getItemById (id) {
    this.setHeader(getAuthToken())
    return this.get(`export-collections/${id}`)
  }

  createItem (payload) {
    this.setHeader(getAuthToken())
    return this.post('export-collections', payload)
  }

  cloneItems (payload) {
    this.setHeader(getAuthToken())
    return this.post('export-collections/clone', payload)
  }

  updateItem (payload) {
    this.setHeader(getAuthToken())
    return this.put(`export-collections/${payload.id}`, payload)
  }

  updateAllItems (payload) {
    this.setHeader(getAuthToken())

    return this.put('export-collections', payload)
  }

  deleteItem (id) {
    this.setHeader(getAuthToken())
    return this.delete(`export-collections/${id}`)
  }
}

export default ExportCollectionsProvider
